import * as React from 'react';
import { rootProjectionNode } from './node/HTMLProjectionNode.mjs';

function useResetProjection() {
    var reset = React.useCallback(function () {
        var root = rootProjectionNode.current;
        if (!root)
            return;
        root.resetTree();
    }, []);
    return reset;
}

export { useResetProjection };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/projection/use-reset-projection.mjs
// module id = LpsB
// module chunks = 0